import script from "./CustomerForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerForm.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerForm.vue?vue&type=style&index=0&id=511a7f14&scoped=true&lang=css"

import exportComponent from "/builds/nmhwyAssu/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511a7f14"]])

export default __exports__